const spitBands = (band, data) => {
  if (band === "first50") {
    return grabObject(0, data);
  } else if (band == "secondBand") {
    return grabObject(50, data);
  } else if (band == "thirdBand") {
    return grabObject(100, data);
  } else if (band == "fourthBand") {
    return grabObject(200, data);
  } else if (band == "fifthBand") {
    return grabObject(300, data);
  } else if (band == "finalBand") {
    return grabObject(400, data);
  }
};
const grabObject = (min_units, data) => {
  let obj = null;
  data.forEach((el) => {
    if (min_units == el.min_units) {
      obj = el;
    }
  });
  return obj;
};
export default spitBands;
